/**
 * Client-side detection (mirrors backend BlockchainInputDetector).
 * @returns {{ chain: string, type: string, query: string, label: string } | null}
 */
export function detectBlockchainInput(raw) {
  const query = String(raw || '').trim();
  if (!query) {
    return null;
  }

  if (/^PRCTX[A-Z0-9]{28}$/i.test(query)) {
    return result('prc', 'transaction', query, 'PRC Transaction Hash');
  }

  if (/^PRC[A-Z0-9]{29}$/i.test(query) && !/^PRCTX/i.test(query)) {
    return result('prc', 'transaction', query, 'PRC Transaction Hash');
  }

  if (/^PRC[A-F0-9]{32}$/i.test(query)) {
    return result('prc', 'address', query, 'PRC Wallet Address');
  }

  if (/^USDT[A-F0-9]{32}$/i.test(query)) {
    return result('prc', 'address', query, 'PRC Pool Address');
  }

  if (/^0x[a-fA-F0-9]{64}$/.test(query)) {
    return result('evm', 'transaction', query, 'EVM Transaction Hash');
  }

  if (/^0x[a-fA-F0-9]{40}$/.test(query)) {
    return result('evm', 'address', query, 'EVM Wallet Address');
  }

  if (/^0x[a-fA-F0-9]+$/i.test(query)) {
    return result('evm', 'block', query, 'EVM Block');
  }

  if (/^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(query)) {
    return result('tron', 'address', query, 'Tron Wallet Address');
  }

  if (/^[a-fA-F0-9]{64}$/.test(query)) {
    return result('tron', 'transaction', query, 'Tron Transaction Hash');
  }

  if (/^[0-9]+$/.test(query)) {
    return result('block', 'block', query, 'Block / Slot');
  }

  if (/^[1-9A-HJ-NP-Za-km-z]{86,90}$/.test(query)) {
    return result('solana', 'transaction', query, 'Solana Transaction Signature');
  }

  if (/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(query)) {
    return result('solana', 'address', query, 'Solana Wallet Address');
  }

  return null;
}

function result(chain, type, query, label) {
  return { chain, type, query, label };
}
